export const SCHEDULER_JOB_ID_DATA_KEY = "cos_job_id";
export const SCHEDULER_DRAG_SOURCE_ZONE_DATA_KEY = "cos_scheduler_drag_source_zone";
export const SCHEDULER_BACKLOG_ZONE = "backlog";
export const SCHEDULER_WORKER_ZONE = "worker";

export function setSchedulerDragData(event, jobId, sourceZone) {
    event.dataTransfer.setData(SCHEDULER_JOB_ID_DATA_KEY, jobId);
    if (sourceZone) {
        event.dataTransfer.setData(SCHEDULER_DRAG_SOURCE_ZONE_DATA_KEY, sourceZone);
    }
}

export function getSchedulerDragData(event) {
    return {
        jobId: event.dataTransfer.getData(SCHEDULER_JOB_ID_DATA_KEY),
        sourceZone: event.dataTransfer.getData(SCHEDULER_DRAG_SOURCE_ZONE_DATA_KEY),
    };
}
